import { zodResolver } from '@hookform/resolvers/zod'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import ActionButton from '@repo/ui/action-button'
import { Save2Icon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { endOfDay, startOfDay } from 'date-fns'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { MissionTrackingInput } from '../../../lib/types/models/mission-tracking/mission-tracking-input'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledDateStringInput from '../../elements/inputs/controlled-date-string-input'

const formSchema: ZodType<MissionTrackingInput> = z
  .object({
    startDate: createStringSchema('De'),
    endDate: createStringSchema('À')
  })
  .superRefine((data, ctx) => {
    if (data.startDate && data.endDate) {
      if (startOfDay(data.startDate) > endOfDay(data.endDate)) {
        return ctx.addIssue({
          path: ['startDate'],
          message: 'La date de début doit être avant la date de fin',
          code: z.ZodIssueCode.custom
        })
      }
    }
  })

type Props = {
  isLoading?: boolean
  defaultValues?: Partial<MissionTrackingInput>
  onSubmit: (data: MissionTrackingInput) => void
}

export const MissionTrackingForm = ({ defaultValues, isLoading, onSubmit }: Props) => {
  const form = useForm<MissionTrackingInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className={'bg-white-hover p-3 rounded-xl'}>
          <Typography variant="tag" color={tailwindColors.primary.DEFAULT}>
            Dates du Contrat
          </Typography>

          <div className={'flex flex-row gap-3 mt-3'}>
            <FormField
              control={form.control}
              name={'startDate'}
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledDateStringInput
                      {...field}
                      required
                      label="De"
                      labelClassName="bg-white-hover"
                    />
                  </FormControl>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name={'endDate'}
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledDateStringInput
                      {...field}
                      required
                      label="À"
                      labelClassName="bg-white-hover"
                    />
                  </FormControl>
                </FormItem>
              )}
            />

            <ActionButton
              type={'submit'}
              variant={'ghost'}
              icon={Save2Icon}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
    </Form>
  )
}
